export default "__VITE_ASSET__Dq$WksXi__"